/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                // JavaScript to be fired on all pages
            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
                // TODO: break page specific events out into the correct sections below
                $(document).ready(function () {
                    $(".gallery-image").fancybox();
                    $(".fancybox").fancybox({
                        helpers: {
                            media: true
                        }
                    });
                    $('.btnJoinGeneral').click(function () {
                        //Facebook
                        var _fbq = window._fbq || (window._fbq = []);
                        if (!_fbq.loaded) {
                            var fbds = document.createElement('script');
                            fbds.async = true;
                            fbds.src = '//connect.facebook.net/en_US/fbds.js';
                            var s = document.getElementsByTagName('script')[0];
                            s.parentNode.insertBefore(fbds, s);
                            _fbq.loaded = true;
                        }

                        window._fbq = window._fbq || [];
                        window._fbq.push(['track', '6031786650111', {'value': '0.00', 'currency': 'USD'}]);
                        //End Facebook

                        //Doubleclick
                        /*var axel = Math.random() + "";
                         var a = axel * 10000000000000;
                         document.write('<iframe src="https://5180844.fls.doubleclick.net/activityi;src=5180844;type=gener0;cat=speed0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=' + a + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>');*/
                        //End Doubleclick

                        //Twitter
                        twttr.conversion.trackPid('ntpa1', {tw_sale_amount: 0, tw_order_quantity: 0});
                        //End Twitter

                        //Analytics
                        ga('send', 'event', 'membership', 'click', 'general');
                        //End Analytics
                    });

                    $('.btnJoinPatron').click(function () {
                        //Facebook
                        var _fbq = window._fbq || (window._fbq = []);
                        if (!_fbq.loaded) {
                            var fbds = document.createElement('script');
                            fbds.async = true;
                            fbds.src = '//connect.facebook.net/en_US/fbds.js';
                            var s = document.getElementsByTagName('script')[0];
                            s.parentNode.insertBefore(fbds, s);
                            _fbq.loaded = true;
                        }

                        window._fbq = window._fbq || [];
                        window._fbq.push(['track', '6031786817111', {'value': '0.00', 'currency': 'USD'}]);
                        //End Facebook

                        //Doubleclick
                        /*var axel = Math.random() + "";
                         var a = axel * 10000000000000;
                         document.write('<iframe src="https://5180844.fls.doubleclick.net/activityi;src=5180844;type=patro0;cat=speed0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=' + a + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>');*/
                        //End Doubleclick

                        //Twitter
                        twttr.conversion.trackPid('ntpa2', {tw_sale_amount: 0, tw_order_quantity: 0});
                        //End Twitter

                        //Analytics
                        ga('send', 'event', 'membership', 'click', 'patron');
                        //End Analytics
                    });

                    //Membership templates
                    $('.membership .template-membership .pop-four a').click(function () {
                        ga('send', 'event', 'donate', 'click', 'membership page');
                    });

                    $('.patron-circle .template-membership .pop-four a').click(function () {
                        ga('send', 'event', 'donate', 'click', 'patron circle page');
                    });

                    $('.international-benefactor-circle .template-membership .pop-four a').click(function () {
                        ga('send', 'event', 'donate', 'click', 'IBC page');
                    });

                    //Annual Fund page
                    $('.annual-fund a:contains(Donate now)').click(function () {
                        ga('send', 'event', 'donate', 'click', 'annual fund page');
                    });
                });
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
                $('.mailLink').click(function () {
                    //Facebook
                    var _fbq = window._fbq || (window._fbq = []);
                    if (!_fbq.loaded) {
                        var fbds = document.createElement('script');
                        fbds.async = true;
                        fbds.src = '//connect.facebook.net/en_US/fbds.js';
                        var s = document.getElementsByTagName('script')[0];
                        s.parentNode.insertBefore(fbds, s);
                        _fbq.loaded = true;
                    }

                    window._fbq = window._fbq || [];
                    window._fbq.push(['track', '6031786550911', {'value': '0.00', 'currency': 'USD'}]);
                    //End Facebook

                    //Doubleclick
                    /*var axel = Math.random() + "";
                     var a = axel * 10000000000000;
                     document.write('<iframe src="https://5180844.fls.doubleclick.net/activityi;src=5180844;type=joinm0;cat=speed0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=' + a + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>');*/
                    //End Doubleclick

                    //Twitter
                    twttr.conversion.trackPid('ntpa0', {tw_sale_amount: 0, tw_order_quantity: 0});
                    //End Twitter

                    //Analytics
                    ga('send', 'event', 'email sign up', 'click', 'countdown');
                    //End Analytics
                });

                var targetDate = new Date('Mar 12, 2016 10:00:00').getTime();
                var days, hours, minutes, seconds;

                setInterval(function () {
                    var currentDate = new Date().getTime();
                    var secondsLeft = (targetDate - currentDate) / 1000;

                    days = parseInt(secondsLeft / 86400);
                    secondsLeft = secondsLeft % 86400;

                    hours = parseInt(secondsLeft / 3600);
                    secondsLeft = secondsLeft % 3600;

                    minutes = parseInt(secondsLeft / 60);
                    seconds = parseInt(secondsLeft % 60);

                    $('.countdownDays').text(days);
                    $('.countdownHours').text(hours);
                    $('.countdownMinutes').text(minutes);
                    $('.countdownSeconds').text(seconds);
                }, 1000);

                //check storage
                //if(typeof(Storage) !== "undefined") {
                    //if (sessionStorage.visited) {
                        //has visited, do nothing
                    //} else {
                        //sessionStorage.visited = true;
                        //window.setTimeout(showCountdown, 1500);
                    //}
                //} else {
                    //no support for storage
                //}

								window.setTimeout(showCountdown, 1500);
                function showCountdown() {
                    $('#modalCountdown').modal();
                }
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        },
        '30_hour_opening_celebration' : {
            init: function () {

                $(window).on('scroll', function() {
                    var y_scroll_pos = window.pageYOffset;
                    var scroll_pos_test = 1016;             // set to whatever you want it to be

                    if(y_scroll_pos > scroll_pos_test) {
                        //console.log(y_scroll_pos);
                        $("#activity-key-container,#activity-key-spacer").addClass("lock");
                    } else {
                        $("#activity-key-container,#activity-key-spacer").removeClass("lock");
                    }
                });
                $(".toggle-details").click(function(e){
                    //console.log($(this).attr('href'));
                    e.preventDefault();
                    var link = $(this);
                    var child_details = $(this).parents(".location-toggle").find(".location-details");
                    var mobileOffset = 135;
                    if($(window).width() < 992){
                        mobileOffset = 20;
                    }
                    if(child_details.is(':visible')){
                        child_details.slideUp('fast',function(){
                            if(link.hasClass('close-details')){
                                $('html, body').animate({scrollTop:$(link.attr('href')).offset().top-$('header').height()-mobileOffset}, 500);
                            }
                        });
                    } else {
                        $(".location-details").slideUp('fast');
                        $(".indicator").removeClass("active");
                        child_details.slideDown('fast',function(){
                            $('html, body').animate({scrollTop:$(link.attr('href')).offset().top-$('header').height()-mobileOffset}, 500);
                        });
                    }
                    $(this).find(".indicator").toggleClass("active");
                });
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
